import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ForgotPasswordService } from "./forgot-password-page.service";
import * as alertFunctions from '@foh/shared/data/sweet-alerts';
@Component({
    selector: 'app-forgot-password-page',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.scss']
})

export class ForgotPasswordPageComponent {
    @ViewChild('f') forogtPasswordForm: NgForm;
    
    email :any;

    constructor(private router: Router,
        private route: ActivatedRoute,
        private forgotPasswordService:ForgotPasswordService
        ) { }

    // On submit click, reset form fields
    onSubmit() {
        this.forgotPasswordService.reset({ email : this.email }).subscribe( (response)=>
        {
            alertFunctions.success("Email Sent","Please check your email in order to find out the steps for resetting your password.")
        } );
        this.forogtPasswordForm.reset();
    }

    // On login link click
    onLogin() {
        this.router.navigate(['login']);
    }
}